const student = [
{
    text: 'unique career journey',
    media: 'David_Fang',
    type: 'image',
    desktop: {
        offset: 35,
        degree: -30
    },
    mobile: {
        offset: 70,
        degree: 300
    },
    story: {
        id: 1
    }
}, {
    text: 'commitment to flexibility',
    media: 'Danzel_Pinto',
    type: 'image',
    desktop: {
        offset: 35,
        degree: 85
    },
    mobile: {
        offset: 10,
        degree: 20
    },
    story: {
        id: 2
    }
}, {
    text: 'coaching culture',
    media: 'Brittanie_Wilson',
    type: 'image',
    desktop: {
        offset: 50,
        degree: 85
    },
    mobile: {
        offset: 105,
        degree: -15
    },
    story: {
        id: 3
    }
}, {
    text: 'your cpa journey',
    media: 'Kristen_Miners',
    type: 'image',
    desktop: {
        offset: 20,
        degree: -65
    },
    mobile: {
        offset: 0,
        degree: 30
    },
    story: {
        id: 4
    }
}]

const experienced = [
{
    text: 'unique career journey',
    media: 'Alex_Smith',
    type: 'image',
    desktop: {
        offset: 30,
        degree: -120
    },
    mobile: {
        offset: 70,
        degree: 300
    },
    story: {
        id: 2
    }
}, {
    text: 'commitment to flexibility',
    media: 'Danzel_Pinto',
    type: 'image',
    desktop: {
        offset: 10,
        degree: -5
    },
    mobile: {
        offset: 30,
        degree: 50
    },
    story: {
        id: 1
    }
}, {
    text: 'coaching culture',
    media: 'Brittanie_Wilson',
    type: 'image',
    desktop: {
        offset: 10,
        degree: 90
    },
    mobile: {
        offset: 90,
        degree: 20
    },
    story: {
        id: 3
    }
}]

export default {
    student,
    experienced
}
    